import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
  AUTH_TOKEN,
  INBOX_CALL,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_FACEBOOK,
} from "../constants/Auth";
import {
  showAuthMessage,
  authenticated,
  signOutSuccess,
  signUpSuccess,
  signInWithGoogleAuthenticated,
  signInWithFacebookAuthenticated,
  inboxSuccessAction,
  signIn,
} from "../actions/Auth";

import crudservice from "services/CrudService";

import FirebaseService from "services/FirebaseService";
import JwtAuthService from "services/JwtAuthService";

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const user = yield call(JwtAuthService.login, payload);
      if (!("access_token" in user)) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.access_token);
        yield put(authenticated(user.access_token));
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
    try {
      // const signOutUser = yield call(FirebaseService.signOutRequest);
      // if (signOutUser === undefined) {
      // 	localStorage.removeItem(AUTH_TOKEN);
      // 	yield put(signOutSuccess(signOutUser));
      // } else {
      // 	yield put(showAuthMessage(signOutUser.message));
      // }
      //   const signOutUser = yield call(JwtAuthService.logout);
      localStorage.removeItem(AUTH_TOKEN);
      window.location.pathname("/auth/login");
      //   if (signOutUser.success) {
      //     yield put(signOutSuccess(signOutUser));
      //   } else {
      //     yield put(showAuthMessage(signOutUser.message));
      //   }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    const { full_name, email, password } = payload;
    try {
      const user = yield call(JwtAuthService.signUp, {
        email,
        password,
        full_name,
      });
      if (user.success === "true") {
        signIn({ email, password });
        // yield put(signUpSuccess(localStorage.getItem("auth_token")));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
    try {
      const user = yield call(FirebaseService.signInGoogleRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithGoogleAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
    try {
      const user = yield call(FirebaseService.signInFacebookRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithFacebookAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* inboxSaga() {
  yield takeEvery(INBOX_CALL, function* ({ payload }) {
    console.log("payload here inbox saga", payload);

    try {
      const user = yield call(crudservice.getinbox);

      if (user) {
        console.log("in inbox saga", user);
        yield put(inboxSuccessAction(user));
      } else {
        yield put(inboxSuccessAction([]));
        // localStorage.setItem(AUTH_TOKEN, user.user.uid);
        // yield put(authenticated(user.user.uid));
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(signInWithFBEmail),
    fork(signOut),
    fork(signUpWithFBEmail),
    fork(signInWithFBGoogle),
    fork(signInWithFacebook),
    fork(inboxSaga),
  ]);
}
